import dayjs from "dayjs";
import { History } from "history";
import queryStringParser from "query-string";

import { ListingSearchResult, LodgingSelectionEnum } from "redmond";

import { getConfigTenant, isCorpTenant } from "@capone/common";
import {
  PATH_HOME,
  PATH_STAYS_AVAILABILITY,
  PATH_VACATION_RENTALS_AVAILABILITY,
} from "../../../utils/paths";
import { transformToStringifiedAvailabilityQuery } from "../../shop/utils/queryStringHelpers";

export interface VacationRentalShopQuery {
  listingId: string;
  fromDate: Date | null;
  untilDate: Date | null;
  adultsCount: number;
  childrenCount: number;
  petsCount: number;
  location: string;
  isTravelApp: boolean | false;
  isBoosted?: boolean;
  selectedLodgingIndex?: number;
}

export const transformToStringifiedVRQuery = ({
  listingId,
  fromDate,
  untilDate,
  adultsCount = 2,
  childrenCount = 0,
  petsCount = 0,
  location,
  isTravelApp = false,
  isBoosted,
  selectedLodgingIndex,
}: VacationRentalShopQuery): string => {
  if (fromDate === null || untilDate === null) {
    return `?listingId=${listingId}`;
  }

  const formatFrom = dayjs(fromDate).format("YYYY-MM-DD");
  const formatUntil = dayjs(untilDate).format("YYYY-MM-DD");

  let string = `?listingId=${listingId}&locationName=${location}&fromDate=${formatFrom}&untilDate=${formatUntil}&adultsCount=${adultsCount}&childrenCount=${childrenCount}&petsCount=${petsCount}`;

  if (isTravelApp) {
    string += `&isTravelApp=${isTravelApp}`;
  }
  if (isBoosted) {
    string += `&isBoosted=true`;
  }
  if (selectedLodgingIndex != null) {
    string += `&selectedLodgingIndex=${selectedLodgingIndex}`;
  }
  return string;
};

export interface IVacationRentalShopParsedQuery {
  listingId: string;
  fromDate: string;
  untilDate: string;
  adultsCount: number;
  childrenCount: number;
  petsCount: number;
  location: string;
  lodgingSelection?: string;
  tabView?: string;
  isTravelApp?: boolean;
  isBoosted?: boolean;
}

export const goToVRAvailability = ({
  history,
  listing,
  fromDate,
  untilDate,
  adultsCount,
  childrenCount,
  petsCount,
}: {
  history: History;
  listing?: ListingSearchResult | null;
  fromDate: Date | null;
  untilDate: Date | null;
  adultsCount: number;
  childrenCount: number;
  petsCount?: number;
}) => {
  if (!listing) {
    return history.push(PATH_HOME);
  }

  const isCorporate = isCorpTenant(getConfigTenant());

  const parsedQueryStringPrimitive = queryStringParser.parse(
    history.location.search
  );

  const location = decodeURIComponent(
    parsedQueryStringPrimitive.locationName as string
  );

  let encodedLodgingLocation: string | null = null;
  try {
    const lodgingSelection = JSON.parse(
      decodeURIComponent(parsedQueryStringPrimitive.lodgingSelection as string)
    );

    encodedLodgingLocation = encodeURIComponent(
      lodgingSelection.LodgingSelection === LodgingSelectionEnum.Place
        ? lodgingSelection.searchTerm
        : lodgingSelection
    );
  } catch {
    // ignore error and rely on encodedLocation
  }

  const encodedLocation = encodeURIComponent(location);

  const search = transformToStringifiedAvailabilityQuery({
    location: isCorporate
      ? encodedLodgingLocation || encodedLocation
      : encodedLocation,
    fromDate,
    untilDate,
    adultsCount,
    childrenCount,
    petsCount,
  });

  history.push(
    `${
      isCorporate ? PATH_STAYS_AVAILABILITY : PATH_VACATION_RENTALS_AVAILABILITY
    }${search}`
  );
};
